import { PartnerClient } from '../partnerClient';
import backend from './services/backend';
import loyalty from './services/loyalty';

export const createQueryService = (apiClient: PartnerClient) => ({
  backend: backend(apiClient),
  loyalty: loyalty(apiClient)
});
